import { boot } from "quasar/wrappers";

import { IFrameActions } from "src/constants";
import { usePersistedStore } from "src/stores/persisted-store";
import { useCommonStore } from "src/stores/common-store";
import { useUserInfo } from "src/stores/user-store";
import { inIframe, sendMessageToParentApp } from "src/utils";
import { useDialogStore } from "src/stores/dialog-store";
import { updateDialogState } from "src/utils/dialogHelper";
import { getAccountID } from "src/utils/commonFunction";

export default boot(({ app, store, router, urlPath }) => {
  const getShouldExitFn = () => {
    let accountId = getAccountID();

    return (
      (accountId && router?.currentRoute?._value?.name === "StoreDetail") ||
      (!accountId && router?.currentRoute?._value?.name === "Home")
    );
  };

  if (typeof window === "undefined") return;

  let persistedStore = usePersistedStore(),
    dialogStore = useDialogStore(),
    userStore = useUserInfo();

  if (inIframe())
    window.addEventListener("message", (event) => {
      // Accept only specific origins messages.
      // if (event.origin !==  "https://..") {
      //   console.log('Incorrect origin',event.origin);
      //   return;
      // }

      const message = event?.data,
        action = message?.action,
        value = message?.value;

      switch (action) {
        case IFrameActions.MAP_USER:
          if (value) persistedStore.addUser(value);
          break;

        case IFrameActions.NAVIGATION:
          router.replace(value || "/");
          break;

        case "FIREBASE_TOKEN":
          if (value?.length > 0 && persistedStore.isLoggedIn) {
            persistedStore.firebaseOldToken = value;
            userStore.setfcmTokenForUser({ reg_token: value });
          }
          break;

        case "CORDOVA_NAVIGATE_BACK":
          const shouldExit = getShouldExitFn();

          if (dialogStore?.dialogHistory?.length) {
            updateDialogState({
              dialog:
                dialogStore?.dialogHistory[
                  dialogStore?.dialogHistory.length - 1
                ],
              val: false,
            });
          } else if (shouldExit) {
            sendMessageToParentApp({
              action: "CLOSE_LNS_APP",
            });
          } else {
            router.go(-1);
          }
          break;

        case "REMOVE_FIRE_BASE_TOKEN":
          userStore.logOutApi().finally(() => {
            sendMessageToParentApp({
              action: "REMOVE_FIRE_BASE_TOKEN_SUCCESS",
            });
          });
      }
    });
});
